export default "__VITE_ASSET__B64L90XJ__"